import type { IconFieldDesignTokens, IconFieldTokenSections } from '@primeuix/themes/types/iconfield';

export const icon: IconFieldTokenSections.Icon = {
    color: '{form.field.icon.color}'
};

export default {
    icon
} satisfies IconFieldDesignTokens;
